import axios from "axios";
import myAppConfig from "../../config";

const BASE = myAppConfig.api.ENDPOINT + "/api/v1/notification";

const NotificationMessageService = {
  /**
   * GET /api/v1/notifications/all_messages/{user_notification_id}
   * Retourne tous les messages d'une veille.
   */
  getMessagesForNotification: (userNotificationId) =>
    axios.get(`${BASE}/all_messages/${userNotificationId}`),
};

export default NotificationMessageService;